import React from 'react'
import HeroSlider from '../HeroSlider/HeroSlider'
import Service from './Service/Service'
import Hiring from './Hiring/Hiring'
import FaqSection from './FaqSection/FaqSection'
import CombinedMarqueeFill from '../Service/WhatWeDo/WhatWeDo'
import LogoMarquee from './LogoMarquee/LogoMarquee'
import TestimonialSlider from './TestimonialSlider/TestimonialSlider'
import HeroCarousel from '../HeroCarousel'
import HeroSectionCarousel from '../HeroSectionCarousel/HeroSectionCarousel'

function Home() {
  return (
    <div>
<HeroSectionCarousel/>
<LogoMarquee/>
<Service/>
<Hiring/>
<FaqSection/>

<div style={{background:"white"}}>
<CombinedMarqueeFill/>
</div>
<TestimonialSlider/>
    </div>
  )
}

export default Home